// TODO: migrate to @gandi/resource
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsLoadedOneOrganization, selectIsFailureOneOrganization, selectIsToRefetchOneOrganization, selectIsFetchingOneOrganization, selectOneOrganization, fetchOneOrganization } from '@gandi/redux-organization';
// XXX: move to redux-organization or use createSequoiaResource
const selectShouldFetchOne = (state, orgId) => {
  const isLoaded = selectIsLoadedOneOrganization(state, orgId);
  const isFailure = selectIsFailureOneOrganization(state, orgId);
  const isToRefetch = selectIsToRefetchOneOrganization(state, orgId);
  const isFetching = selectIsFetchingOneOrganization(state, orgId);

  // same algo as @gandi/resource
  return (!isLoaded && !isFailure || isToRefetch) && !isFetching;
};
export const eventuallyFetchOneOrganization = orgId => (dispatch, getState) => {
  if (selectShouldFetchOne(getState(), orgId)) {
    return dispatch(fetchOneOrganization(orgId));
  }
  return undefined;
};
export const useOneOrganization = orgId => {
  const isValidOrgId = orgId !== '';
  const dispatch = useDispatch();
  const shouldFetch = useSelector(state => isValidOrgId && selectShouldFetchOne(state, orgId));
  React.useEffect(() => {
    if (shouldFetch && orgId !== '') {
      dispatch(eventuallyFetchOneOrganization(orgId));
    }
  }, [dispatch, orgId, shouldFetch]);
  const organization = useSelector(state => isValidOrgId ? selectOneOrganization(state, orgId) : undefined);
  const isLoaded = useSelector(state => isValidOrgId && selectIsLoadedOneOrganization(state, orgId));
  const isFetching = useSelector(state => isValidOrgId && selectIsFetchingOneOrganization(state, orgId));
  const isFailure = useSelector(state => isValidOrgId && selectIsFailureOneOrganization(state, orgId));
  const isToRefetch = useSelector(state => isValidOrgId && selectIsToRefetchOneOrganization(state, orgId));
  return {
    organization,
    isLoaded,
    isFetching,
    isFailure,
    isToRefetch
  };
};
useOneOrganization.preFetch = ({
  dispatch,
  orgId
}) => dispatch(eventuallyFetchOneOrganization(orgId));